import { type BroadcastChannelPort, createBroadcastChannel } from "./broadcast";

export const INVALIDATION_CHANNEL_NAME = "atd-query-invalidation-v1";

export interface InvalidationMessage {
  /** An opaque TanStack query key. This channel knows nothing about the domain. */
  queryKey: readonly unknown[];
}

export type InvalidationChannel = BroadcastChannelPort<InvalidationMessage>;

const parseMessage = (value: unknown): InvalidationMessage | undefined => {
  if (typeof value !== "object" || value === null || !("queryKey" in value)) {
    return undefined;
  }
  return Array.isArray(value.queryKey)
    ? { queryKey: value.queryKey }
    : undefined;
};

export const createInvalidationChannel = (
  name = INVALIDATION_CHANNEL_NAME,
): InvalidationChannel => createBroadcastChannel(name, parseMessage);
